import { Component, Input, OnInit } from '@angular/core';
import { RenaultAnimationActionDetailDTO, RenaultAnimationActionRemuneration } from '../../../models/renault-animation-action-dto';
import { AnimationActionService } from 'src/app/services/animation-action.service';
import { RenaultMyServiceActionModel, RenaultMyServiceActionRemunerationList, RenaultMyServiceActionRemunerationModel } from 'src/app/models/renault-myservice-dto';
import { MyServiceService } from 'src/app/services/myservice.service';

@Component({
  selector: 'myservice-action-detail-card',
  templateUrl: './myservice-action-detail-card.component.html',
  styleUrls: ['./myservice-action-detail-card.component.scss']
})
export class MyServiceActionDetailCardComponent implements OnInit {


  @Input() modelRemuneration: RenaultMyServiceActionRemunerationModel;
  @Input() isOpen: boolean = false;


  constructor(private service: MyServiceService) { }

  ngOnInit(): void {



  }


}
